export default class Theme {
	// Init vars
	theme = 'light';
	themeButtons = document.querySelectorAll('.jsThemeToggle');
	// userPreference = this.getUserPreference();
	prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

	constructor() {
		this.initTheme();
		this.watchToggles();
	}

	initTheme() {
		let userPreference = this.getUserPreference();
		if ( userPreference ) {
			if ( ['light','dark'].includes(userPreference) ) {
				this.setTheme( userPreference );
			} else {
				this.deleteUserPreference();
				this.useBrowserPreference();
			}
		} else {
			this.useBrowserPreference();
		}
	}

	setCookie(cName, cValue, expDays) {
		let date = new Date();
		date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
	}

	getCookie(cName) {
		const name = cName + "=";
		const cDecoded = decodeURIComponent(document.cookie); //to be careful
		const cArr = cDecoded.split('; ');
		let res;
		cArr.forEach(val => {
			if (val.indexOf(name) === 0) res = val.substring(name.length);
		})
		return res;
	}

	// Cookie method
	getUserPreference() {
		return this.getCookie('theme');
	}

	setUserPreference(newTheme) {
		this.setCookie('theme', newTheme, 365);
	}

	deleteUserPreference( ) {
		this.setCookie('theme', null, 0);
	}

	useBrowserPreference() {
		if ( this.prefersDarkMode ) {
			this.setTheme( 'dark' );
		} else {
			this.setTheme( 'light' );
		}
	}

	isIOSDevice() {
		return /iPad|iPhone|iPod/i.test(navigator.userAgent) && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
	}

	setTheme( theme ) {
		if (theme == 'dark') {
			document.documentElement.classList.remove('light');
			document.documentElement.classList.add('dark');
			// document.body.classList.remove('bg-white');
			// document.body.classList.add('bg-black');
		} else {
			document.documentElement.classList.remove('dark');
			document.documentElement.classList.add('light');
			// document.body.classList.remove('bg-black');
			// document.body.classList.add('bg-white');
		}

		if (this.isIOSDevice()) {
			// Force iphone to repaint
			document.documentElement.style.display = 'none';
			document.documentElement.offsetHeight; // Trigger a reflow
			document.documentElement.style.display = '';
		}
	}

	watchToggles() {
		// Watch for clicks on each theme toggle button
		this.themeButtons.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				this.handleClick(e);
			});
		});
	}

	handleClick(e) {
		/* if (e.ctrlKey) {
			// Delete the saved theem from Local Storage
			this.deleteUserPreference()
			// Initialise the theme to the default settings
			this.initTheme();

			// Show Notification
			const notificationOpts = {
				elementId: 'notification',
				text: 'Theme reset to automatic.',
				iconId: 'info',
				timeout: 3000
			}
			this.showNotification(notificationOpts);
		} else { */
		// document.documentElement.offsetHeight;
			// Get the current theme from the <html data-theme=""> attr
			// const currentTheme = document.documentElement.dataset.theme;
			const currentTheme = document.documentElement.classList.contains('light') ? 'light' : 'dark';
			// Figure out what the new theme is
			const newTheme = currentTheme === 'light' ? 'dark' : 'light';
			// Set the site theme to the new theme
			this.setTheme( newTheme )
			// Save the new theme to Local Storage
			this.setUserPreference(newTheme);

			this.setMetaInformations(newTheme);
		/* } */
	}

	showNotification(options) {
		const notificationEl = document.getElementById(options.elementId) || console.error('Unable to find an element with the `ID` of `' + options.elementId + '`.');
		notificationEl.querySelector('.jsNotificationIcon use').setAttribute('href', "#icon-"+options.iconId);
		notificationEl.querySelector('.jsNotificationContent').innerText = options.text;
		if (options.timeout) {
			const progress = notificationEl.querySelector('.jsNotificationProgress');
			const sanitizedTimeout = parseInt(options.timeout, 10);
			const timeout = isNaN(sanitizedTimeout) || sanitizedTimeout <= 0 ? 5000 : sanitizedTimeout;

			// Set length of progress bar to allow a 30fps progression rate
			progress.value = 0;
			let currentValue = 0;
			const max = timeout / 1000 * 60;
			progress.setAttribute('max', max);

			// Animate bar
			const animateProgress = () => {
				if (currentValue < max) {
					currentValue++;
					progress.value = currentValue;
				} else {
					// Stop the animation when reaching the max value
					clearInterval(animationInterval);
				}
			};
			const animationInterval = setInterval(animateProgress, 16); // ~60fps

			setTimeout(() => { notificationEl.close(); }, timeout);
		}
		notificationEl.show();
	}

	setMetaInformations(newTheme) {
		if(typeof(radicalrelaventChart) !== "undefined") {
			radicalrelaventChart.update();
		}
	}
}